import { SET_LOADING, MENU_TOGGLER } from './types';

export const setLoading = (loadingState) => {
  return {
    type: SET_LOADING,
    payload: loadingState,
  };
};

export const setMenuToggler = () => ({ type: MENU_TOGGLER });
